import React from "react";
import { UserConfigurationPersistence } from "../types";

export const UserConfigurationPersistenceContext = React.createContext<UserConfigurationPersistence | undefined>(undefined);
